export const movies = [
  {
    id: 'm-001',
    title: '星际回声',
    type: 'movie',
    genres: ['科幻', '冒险'],
    year: 2024,
    region: '美国',
    duration: '142分钟',
    rating: 8.7,
    director: '林昭远',
    cast: ['陈牧野', '苏黎', '顾清和'],
    summary:
      '一支深空勘探队在木星轨道外围截获一段重复了三十年的神秘电波。随着信号源被逐步解码，队员们发现那段“回声”记录的，竟是他们自己尚未发生的未来。',
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20of%20a%20lone%20astronaut%20silhouette%20before%20a%20glowing%20ringed%20planet%20deep%20navy%20blue%20cosmos%20warm%20orange%20nebula%20light%20minimal%20dramatic%20composition%20atmospheric%20lighting%20premium%20film%20promotional%20illustration%20deep%20blue%20and%20orange%20color%20scheme&width=400&height=600&seq=mv001p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20sci-fi%20film%20still%20of%20a%20vast%20deep%20navy%20blue%20starfield%20with%20a%20glowing%20ringed%20planet%20on%20the%20horizon%20an%20astronaut%20silhouetted%20in%20the%20foreground%20warm%20orange%20nebula%20glow%20epic%20atmospheric%20lighting%20ultra%20detailed%20moody%20cinematic%20color%20grading%20deep%20blue%20and%20orange%20tones&width=1600&height=900&seq=mv001b&orientation=landscape',
    views: 1286000,
    featured: true,
  },
  {
    id: 'm-002',
    title: '暗夜追凶',
    type: 'movie',
    genres: ['犯罪', '悬疑'],
    year: 2023,
    region: '中国大陆',
    duration: '128分钟',
    rating: 8.2,
    director: '周黎声',
    cast: ['魏则安', '许清越', '何嘉树'],
    summary:
      '一桩尘封十五年的连环旧案在新城区重现。退居二线的老刑警与新锐技术警探被迫联手，在雨夜的霓虹与谎言之间，追寻那个始终站在迷雾背后的身影。',
    poster:
      'https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20movie%20poster%20of%20a%20lone%20detective%20silhouette%20standing%20in%20a%20rain%20soaked%20neon%20city%20alley%20at%20night%20deep%20navy%20blue%20shadows%20with%20warm%20orange%20street%20lamp%20glow%20dramatic%20noir%20lighting%20cinematic%20composition%20mystery%20atmosphere%20premium%20film%20poster%20illustration&width=400&height=600&seq=mv002p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20rain%20soaked%20night%20city%20alley%20a%20solitary%20detective%20in%20a%20long%20coat%20seen%20from%20behind%20deep%20navy%20blue%20tones%20with%20warm%20orange%20neon%20reflections%20on%20wet%20asphalt%20dramatic%20noir%20lighting%20atmospheric%20fog%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=mv002b&orientation=landscape',
    views: 986000,
    featured: true,
  },
  {
    id: 'm-003',
    title: '时光信箱',
    type: 'movie',
    genres: ['爱情', '奇幻'],
    year: 2024,
    region: '日本',
    duration: '116分钟',
    rating: 7.9,
    director: '中野千夏',
    cast: ['夏川凛', '藤井悠真', '森野葵'],
    summary:
      '小镇上有一只会把信寄往过去的旧信箱。失去未婚妻的邮递员开始每天写信，却在某一封信的回信里，读到了本不该存在的未来日期。',
    poster:
      'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20movie%20poster%20of%20a%20vintage%20red%20mailbox%20standing%20in%20a%20golden%20autumn%20lane%20with%20drifting%20leaves%20soft%20warm%20light%20nostalgic%20dreamy%20atmosphere%20deep%20blue%20twilight%20sky%20with%20warm%20orange%20sunset%20glow%20cinematic%20illustration%20heartfelt%20elegant%20film%20poster%20style&width=400&height=600&seq=mv003p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20quiet%20autumn%20lane%20with%20a%20vintage%20mailbox%20golden%20drifting%20leaves%20a%20distant%20figure%20walking%20away%20soft%20warm%20orange%20sunlight%20against%20a%20deep%20blue%20twilight%20sky%20dreamy%20nostalgic%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=mv003b&orientation=landscape',
    views: 742000,
  },
  {
    id: 'm-004',
    title: '沙海孤城',
    type: 'movie',
    genres: ['动作', '冒险'],
    year: 2022,
    region: '美国',
    duration: '155分钟',
    rating: 8.4,
    director: 'D. 卡森',
    cast: ['马库斯·里德', '艾拉·沃恩', '诺亚·贝克'],
    summary:
      '末世后的商队穿越无尽沙海，只为抵达传说中最后一座有水井的孤城。当沙暴揭开废墟下的秘密，他们才发现这座城早已等待了他们很多年。',
    poster:
      'https://readdy.ai/api/search-image?query=Epic%20action%20adventure%20movie%20poster%20of%20a%20lone%20warrior%20standing%20on%20vast%20wind%20swept%20desert%20dunes%20dramatic%20deep%20blue%20sky%20with%20warm%20orange%20sunset%20dust%20sweeping%20sand%20cinematic%20grandeur%20minimal%20powerful%20composition%20premium%20blockbuster%20poster%20illustration%20blue%20and%20orange%20palette&width=400&height=600&seq=mv004p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20enormous%20desert%20sand%20dunes%20under%20a%20deep%20blue%20dusk%20sky%20a%20tiny%20lone%20traveler%20crossing%20the%20ridge%20warm%20orange%20dust%20light%20sense%20of%20epic%20scale%20and%20solitude%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=mv004b&orientation=landscape',
    views: 1105000,
    featured: true,
  },
  {
    id: 'm-005',
    title: '春山可望',
    type: 'movie',
    genres: ['剧情', '家庭'],
    year: 2024,
    region: '中国大陆',
    duration: '124分钟',
    rating: 8.9,
    director: '宋知遥',
    cast: ['梁守正', '叶汀兰', '申屠远'],
    summary:
      '一位退休的乡村教师用十年时间，把一座即将撤点的小学重新变成孩子们眺望远方的窗口。这是一部关于坚守、告别与希望的温柔之作。',
    poster:
      'https://readdy.ai/api/search-image?query=Poetic%20drama%20movie%20poster%20of%20misty%20layered%20green%20mountains%20at%20dawn%20with%20a%20distant%20solitary%20figure%20on%20a%20stone%20path%20soft%20light%20tranquil%20contemplative%20mood%20subtle%20warm%20orange%20sunrise%20glow%20elegant%20minimal%20composition%20award%20winning%20film%20poster%20illustration%20style&width=400&height=600&seq=mv005p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20misty%20layered%20mountains%20at%20sunrise%20soft%20rolling%20fog%20over%20green%20valleys%20a%20small%20lone%20figure%20on%20a%20winding%20stone%20path%20serene%20contemplative%20atmosphere%20warm%20orange%20dawn%20light%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=mv005b&orientation=landscape',
    views: 663000,
  },
  {
    id: 'm-006',
    title: '深海之下',
    type: 'movie',
    genres: ['科幻', '惊悚'],
    year: 2023,
    region: '英国',
    duration: '133分钟',
    rating: 7.6,
    director: 'E. 哈洛威',
    cast: ['莉迪亚·格林', '托马斯·凯恩', '艾米·肖'],
    summary:
      '海沟最深处，一艘载人潜航器与地表失去联系。在氧气耗尽之前，船员们必须先弄清楚：让他们不断下沉的，究竟是仪器故障，还是来自深渊的召唤。',
    poster:
      'https://readdy.ai/api/search-image?query=Tense%20sci-fi%20thriller%20movie%20poster%20of%20a%20deep%20sea%20submersible%20descending%20into%20abyssal%20darkness%20with%20bioluminescent%20particles%20deep%20navy%20blue%20water%20faint%20warm%20orange%20instrument%20glow%20claustrophobic%20atmosphere%20cinematic%20underwater%20illustration%20premium%20film%20poster%20style&width=400&height=600&seq=mv006p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20underwater%20film%20still%20of%20a%20small%20submersible%20descending%20into%20the%20deep%20dark%20ocean%20deep%20navy%20blue%20water%20with%20bioluminescent%20specks%20a%20faint%20warm%20orange%20light%20beam%20vast%20and%20eerie%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=mv006b&orientation=landscape',
    views: 588000,
  },
  {
    id: 'm-007',
    title: '城市之光·归途',
    type: 'movie',
    genres: ['动作', '犯罪'],
    year: 2025,
    region: '中国香港',
    duration: '138分钟',
    rating: 8.1,
    director: '麦承轩',
    cast: ['关仲恒', '阮清'],
    summary:
      '潜伏多年的卧底终于拿到足以扳倒整条犯罪链的证据，却在最后一夜被组织识破。他必须穿过一座不眠之城，把证据和真相一起带回黎明。',
    poster:
      'https://readdy.ai/api/search-image?query=Urban%20action%20movie%20poster%20of%20a%20lone%20figure%20standing%20on%20a%20rooftop%20overlooking%20a%20vast%20city%20skyline%20at%20dusk%20deep%20navy%20blue%20sky%20warm%20orange%20city%20lights%20below%20dramatic%20cinematic%20composition%20moody%20heroic%20atmosphere%20premium%20film%20poster%20illustration&width=400&height=600&seq=mv007p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20vast%20modern%20city%20skyline%20at%20dusk%20seen%20from%20a%20rooftop%20one%20lone%20figure%20silhouetted%20against%20the%20deep%20blue%20sky%20thousands%20of%20warm%20orange%20city%20lights%20below%20dramatic%20heroic%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=mv007b&orientation=landscape',
    views: 934000,
  },
  {
    id: 'm-008',
    title: '迷雾森林',
    type: 'movie',
    genres: ['恐怖', '悬疑'],
    year: 2023,
    region: '韩国',
    duration: '109分钟',
    rating: 7.4,
    director: '朴镇宇',
    cast: ['韩序真', '吴宥拉', '李世准'],
    summary:
      '五名大学生进入一片从未被标注在地图上的森林做课题拍摄。当雾气升起，他们发现每一次回头，队伍里都会多出一个人。',
    poster:
      'https://readdy.ai/api/search-image?query=Atmospheric%20horror%20mystery%20movie%20poster%20of%20a%20dark%20foggy%20forest%20with%20tall%20bare%20trees%20a%20faint%20warm%20orange%20lantern%20glow%20deep%20in%20the%20mist%20deep%20navy%20blue%20shadows%20unsettling%20eerie%20atmosphere%20cinematic%20minimal%20composition%20premium%20thriller%20poster%20illustration&width=400&height=600&seq=mv008p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20dense%20foggy%20forest%20at%20night%20tall%20bare%20trees%20fading%20into%20deep%20navy%20blue%20mist%20a%20faint%20warm%20orange%20glow%20between%20the%20trunks%20eerie%20unsettling%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=mv008b&orientation=landscape',
    views: 471000,
  },
  {
    id: 'm-009',
    title: '银河邮差',
    type: 'movie',
    genres: ['动画', '冒险'],
    year: 2024,
    region: '美国',
    duration: '98分钟',
    rating: 8.6,
    director: '安娜·费舍尔',
    cast: ['配音：李维', '配音：祁小满', '配音：奥利'],
    summary:
      '宇宙最慢的邮差意外收到一封必须在一周内送达的信。为了赶上那趟跨越星系的末班飞船，他和一只话多的机器猫踏上了荒唐又温暖的旅程。',
    poster:
      'https://readdy.ai/api/search-image?query=Whimsical%20animated%20space%20adventure%20poster%20of%20a%20cheerful%20young%20courier%20riding%20a%20small%20rocket%20between%20colorful%20planets%20deep%20navy%20blue%20space%20with%20warm%20orange%20and%20golden%20stars%20playful%20charming%20illustration%20family%20friendly%20animated%20film%20poster%20style&width=400&height=600&seq=mv009p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20animated%20film%20still%20of%20a%20whimsical%20young%20space%20courier%20on%20a%20small%20rocket%20flying%20through%20deep%20navy%20blue%20cosmos%20colorful%20glowing%20planets%20and%20warm%20orange%20stardust%20playful%20charming%20atmosphere%20vibrant%20illustration%20ultra%20detailed&width=1600&height=900&seq=mv009b&orientation=landscape',
    views: 1342000,
    featured: true,
  },
  {
    id: 'm-010',
    title: '第七封印之外',
    type: 'movie',
    genres: ['悬疑', '剧情'],
    year: 2022,
    region: '法国',
    duration: '121分钟',
    rating: 8.0,
    director: '让-吕克·莫罗',
    cast: ['艾蒂安·拉罗', '卡米耶·杜邦', '于连·贝赫'],
    summary:
      '一位沉默的棋手在海边小镇与一位陌生人反复对弈。每一局棋的胜负，似乎都对应着镇上一件即将发生的、无从阻止的事。',
    poster:
      'https://readdy.ai/api/search-image?query=Moody%20French%20mystery%20movie%20poster%20of%20a%20lone%20figure%20walking%20across%20a%20windswept%20grey%20blue%20coastal%20plain%20under%20a%20vast%20dramatic%20sky%20deep%20navy%20blue%20tones%20with%20a%20warm%20orange%20break%20of%20light%20at%20the%20horizon%20philosophical%20austere%20mood%20elegant%20film%20poster%20illustration&width=400&height=600&seq=mv010p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20bleak%20windswept%20coastal%20plain%20under%20an%20enormous%20dramatic%20sky%20a%20lone%20distant%20figure%20in%20a%20long%20coat%20deep%20navy%20blue%20tones%20with%20a%20warm%20orange%20glow%20breaking%20at%20the%20horizon%20austere%20philosophical%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=mv010b&orientation=landscape',
    views: 402000,
  },
  {
    id: 'm-011',
    title: '热血少年团',
    type: 'movie',
    genres: ['喜剧', '运动'],
    year: 2024,
    region: '中国大陆',
    duration: '112分钟',
    rating: 7.2,
    director: '赵一鸣',
    cast: ['刘星野', '程亦航', '丁小满'],
    summary:
      '五个被全校公认“最没运动细胞”的少年，为了保住社团而报名参加校际联赛。他们没赢过一场训练赛，却意外成了整座城市最热血的传说。',
    poster:
      'https://readdy.ai/api/search-image?query=Energetic%20comedy%20sports%20movie%20poster%20of%20a%20group%20of%20cheerful%20teenagers%20in%20athletic%20gear%20cheering%20together%20dynamic%20motion%20bright%20warm%20orange%20energy%20deep%20navy%20blue%20background%20fun%20vibrant%20composition%20youthful%20movie%20poster%20illustration%20style&width=400&height=600&seq=mv011p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20lively%20group%20of%20teenagers%20celebrating%20on%20an%20outdoor%20sports%20field%20at%20golden%20hour%20dynamic%20joyful%20energy%20warm%20orange%20sunlight%20deep%20blue%20sky%20vibrant%20youthful%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=mv011b&orientation=landscape',
    views: 521000,
  },
  {
    id: 'm-012',
    title: '雪落长街',
    type: 'movie',
    genres: ['爱情', '剧情'],
    year: 2023,
    region: '中国大陆',
    duration: '119分钟',
    rating: 8.3,
    director: '沈砚秋',
    cast: ['闻砚', '黎知夏', '傅长明'],
    summary:
      '阔别十年的两个人在同一场大雪里回到老街。有些话在雪下埋了太久，直到路灯亮起，他们才终于肯把当年那封没有寄出的信，交给对方。',
    poster:
      'https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20of%20soft%20falling%20snow%20over%20a%20quiet%20old%20city%20street%20lined%20with%20glowing%20warm%20orange%20street%20lamps%20two%20distant%20figures%20deep%20navy%20blue%20winter%20night%20tender%20melancholic%20atmosphere%20elegant%20cinematic%20film%20poster%20illustration&width=400&height=600&seq=mv012p&orientation=portrait',
    backdrop:
      'https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20quiet%20snow%20covered%20old%20city%20street%20at%20night%20warm%20orange%20street%20lamps%20glowing%20through%20gentle%20falling%20snow%20two%20distant%20figures%20walking%20apart%20deep%20navy%20blue%20winter%20tones%20tender%20melancholic%20atmosphere%20ultra%20detailed%20cinematic%20color%20grading&width=1600&height=900&seq=mv012b&orientation=landscape',
    views: 879000,
  },
];